import { Url } from '@wix/da-url';
import { getDeviationType, getPrimaryTier, isDeviationAuthor } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { usePrimaryTier } from '../../Tier/PrimaryTierContext';
import { useCurrentUser } from './useCurrentUser';
/** returns member subscription info for the given deviation */ export function useSubscriptionTier(deviation) {
    const currentUser = useCurrentUser();
    const isOwner = deviation ? isDeviationAuthor(deviation, currentUser) : false;
    const contextualTier = usePrimaryTier();
    const { isTier, isInTier, tier, isUserSubscribed, tierCheckoutUrl, subscriptionsTabUrl, needsSubscription, isSubscribedButBlocked } = getBasicTierSubscriptionInfo(deviation, contextualTier);
    // you are never blocked if
    // - you're the content's owner,
    // - there's no subscription needed
    const subscriptionsMatter = !isOwner && !isTier;
    return {
        isTier,
        isInTier,
        tier,
        isOwner,
        isUserSubscribed,
        tierCheckoutUrl,
        subscriptionsTabUrl,
        needsSubscription: subscriptionsMatter && needsSubscription,
        isSubscribedButBlocked: subscriptionsMatter && isSubscribedButBlocked
    };
}
/**
 * Get the basic tier info without react dependency
 */ export function getBasicTierSubscriptionInfo(deviation, contextualTier) {
    var _deviation_tier, _deviation, _primaryTierFromDeviation_tier, _primaryTierFromDeviation, _tier_tier, _tier, _tier1, _deviation1;
    const primaryTierFromDeviation = deviation && getPrimaryTier(deviation);
    const primaryTier = contextualTier || primaryTierFromDeviation;
    const isTier = deviation ? getDeviationType(deviation) === DeviationTypes.TIER : false;
    const isInTier = !!primaryTier;
    const tier = isTier ? deviation : primaryTier;
    const isUserSubscribed = isTier ? !!((_deviation_tier = (_deviation = deviation) === null || _deviation === void 0 ? void 0 : _deviation.tier) === null || _deviation_tier === void 0 ? void 0 : _deviation_tier.isUserSubscribed) : !!((_primaryTierFromDeviation_tier = (_primaryTierFromDeviation = primaryTierFromDeviation) === null || _primaryTierFromDeviation === void 0 ? void 0 : _primaryTierFromDeviation.tier) === null || _primaryTierFromDeviation_tier === void 0 ? void 0 : _primaryTierFromDeviation_tier.isUserSubscribed);
    const tierCheckoutUrl = ((_tier_tier = (_tier = tier) === null || _tier === void 0 ? void 0 : _tier.tier) === null || _tier_tier === void 0 ? void 0 : _tier_tier.subproductId) ? Url.checkoutLink(tier.tier.subproductId) : undefined;
    const subscriptionsTabUrl = ((_tier1 = tier) === null || _tier1 === void 0 ? void 0 : _tier1.author) ? Url.userLink(tier.author.username, '/subscriptions') : undefined;
    const needsSubscription = !!tier && !isUserSubscribed;
    const isSubscribedButBlocked = ((_deviation1 = deviation) === null || _deviation1 === void 0 ? void 0 : _deviation1.tierAccess) === 'locked-subscribed';
    return {
        isTier,
        isInTier,
        tier,
        isUserSubscribed: isUserSubscribed,
        tierCheckoutUrl,
        subscriptionsTabUrl,
        needsSubscription,
        isSubscribedButBlocked
    };
}
